/**
 * Статус записи обучения в истории матчей (Match.tutorialStatus).
 *
 * Запись о главе создается в момент СТАРТА прохождения (in_progress), а не
 * по его окончании, как у остальных матчей: по недоигранным главам видно, где
 * игроки бросают обучение. Прохождение главы переводит запись в completed.
 *
 * У записей обучения, созданных до этого (их писали только при завершении
 * главы), статуса нет вовсе — они считаются пройденными.
 */
export const TUTORIAL_MATCH_STATUSES = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
};
